import {MaterialConnection} from "#material/nodes/base/connection/material-connection"
import type {OutputMaterialConnection, SettingsDefinition, SocketsDefinition, SocketValueOfType} from "#material/sockets/definition"
import type {MaterialNodeLike} from "#material/types/material-connection"
import type {SocketValueType} from "#material/sockets/socket-value-type"

export function materialConnection<
    TInputs extends SocketsDefinition,
    TSettings extends SettingsDefinition,
    TSettingsExtensions extends {[name: string]: any},
    TOutputs extends SocketsDefinition,
    KeyType extends string & keyof TOutputs,
    Value extends SocketValueType = TOutputs[KeyType],
>(
    value: MaterialNodeLike<{
        inputs: TInputs
        inputsExtensions: {}
        settings: TSettings
        settingsExtensions: TSettingsExtensions
        outputs: TOutputs
    }>,
    key: KeyType,
    id?: string,
    legacyId?: number,
): OutputMaterialConnection<Value> {
    const connection = new MaterialConnection<SocketValueOfType<Value>>({
        parameters: {
            key,
            //@ts-expect-error TypeScript infers the type of value correctly
            value,
        },
    })
    if (id) {
        connection.instanceId = id
    }
    if (legacyId) {
        connection.legacyId = legacyId
    }
    return connection
}
